module.exports = __webpack_public_path__ + "static/media/front.ad9d88df.jpg";